








import {
  defineComponent,
  PropType,
} from '@vue/composition-api';
import type {
  HokkaidoAirportSettings,
} from '@/models/apis/externalReports/hokkaidoAirport/hokkaidoAirportSettings';
import { downloadObjectUrl } from '@/lib/downloadHelper';

export default defineComponent({
  props: {
    userSettings: {
      type: Object as PropType<HokkaidoAirportSettings>,
      required: true,
    },
  },
  setup(props) {
    const downloadManual = () => {
      const manualName = props.userSettings.common.manual_download_file_name || 'manual.pdf';
      downloadObjectUrl(props.userSettings.common.manual_download_link, manualName);
    };
    return {
      downloadManual,
    };
  },
});
